import React from "react";
import BlockContainer from "../AppraisalDetails/BlockContainer";
import useArticles from "../../../hooks/useArticles";

const ImportantDocuments = ({ isNz }) => {
  const importantDocumentsArticle = useArticles({ importantDocuments: true })
    .importantDocuments?.[0];

  if (!importantDocumentsArticle) return null;

  if (!isNz) return null;

  return (
    <BlockContainer
      defaultTitle={importantDocumentsArticle.title}
      defaultSubtitle={"Make sure to review before you sign up"}
      id="important-documents"
      hide={false}
    >
      <div className="mb-10">
        <div
          className="mce-content-body"
          dangerouslySetInnerHTML={{
            __html: importantDocumentsArticle.body,
          }}
        />
      </div>
    </BlockContainer>
  );
};

export default ImportantDocuments;
